import { createStore, applyMiddleware, compose } from 'redux'
import thunk from 'redux-thunk'
import promise from 'redux-promise-middleware'
import appReducers from '../reducers'
import storageClient from '../services/Storage'

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(
    appReducers,
    composeEnhancers(applyMiddleware(
      promise(),
      thunk
    ))
  )

storageClient.initialize(store, () =>  {

  storageClient.getItem('patagonia.user.data', (data) => {
    if (data) store.dispatch({ type: "LOGIN", payload: data})
  })

})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js